document.addEventListener('DOMContentLoaded', function() {
  const smsToggle = document.getElementById('sms-toggle');
  const emailToggle = document.getElementById('email-toggle');
  const smsStatus = document.getElementById('sms-status');
  const emailStatus = document.getElementById('email-status');

  // Initialize toggles based on current customer preferences
  function initializeToggles() {
    // Get current marketing preferences from customer data
    const currentMarketingStatus = null;
    
    // Set initial states
    if (smsToggle) {
      smsToggle.checked = currentMarketingStatus;
      updateStatusIndicator(smsStatus, currentMarketingStatus);
    }
    
    if (emailToggle) {
      emailToggle.checked = currentMarketingStatus;
      updateStatusIndicator(emailStatus, currentMarketingStatus);
    }
  }

  // Update status indicator
  function updateStatusIndicator(statusElement, isActive) {
    if (statusElement) {
      statusElement.textContent = isActive ? 'Active' : 'Inactive';
      statusElement.className = `status-indicator ${isActive ? 'active' : 'inactive'}`;
    }
  }

  // Show loading state
  function setLoadingState(toggleElement, isLoading) {
    if (toggleElement) {
      const toggleSwitch = toggleElement.closest('.toggle-switch');
      if (isLoading) {
        toggleSwitch.classList.add('loading');
        toggleElement.disabled = true;
      } else {
        toggleSwitch.classList.remove('loading');
        toggleElement.disabled = false;
      }
    }
  }

  // Update customer preferences in Shopify
  async function updateCustomerPreferences(type, enabled) {
    try {
      const response = await fetch('/account/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams({
          'form_type': 'customer',
          'utf8': '✓',
          'customer[accepts_marketing]': enabled ? '1' : '0',
          'customer[email]': '',
          'customer[first_name]': '',
          'customer[last_name]': ''
        })
      });

      if (response.ok) {
        // Show success message
        showNotification(`${type} preferences updated successfully!`, 'success');
        return true;
      } else {
        throw new Error('Failed to update preferences');
      }
    } catch (error) {
      console.error('Error updating preferences:', error);
      showNotification(`Failed to update ${type} preferences. Please try again.`, 'error');
      return false;
    }
  }

  // Show notification
  function showNotification(message, type) {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `preference-notification ${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 12px 20px;
      border-radius: 6px;
      color: white;
      font-weight: 500;
      z-index: 10000;
      animation: slideIn 0.3s ease-out;
      ${type === 'success' ? 'background-color: #28a745;' : 'background-color: #dc3545;'}
    `;

    // Add animation styles
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOut {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    document.head.appendChild(style);

    // Add to page
    document.body.appendChild(notification);

    // Remove after 3 seconds
    setTimeout(() => {
      notification.style.animation = 'slideOut 0.3s ease-in';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }

  // Handle SMS toggle
  if (smsToggle) {
    smsToggle.addEventListener('change', async function() {
      const isEnabled = this.checked;
      const statusElement = smsStatus;
      
      // Set loading state
      setLoadingState(this, true);
      
      // Update status indicator immediately for better UX
      updateStatusIndicator(statusElement, isEnabled);
      
      // Update preferences in Shopify
      const success = await updateCustomerPreferences('SMS', isEnabled);
      
      // Remove loading state
      setLoadingState(this, false);
      
      // Revert if update failed
      if (!success) {
        this.checked = !isEnabled;
        updateStatusIndicator(statusElement, !isEnabled);
      }
    });
  }

  // Handle Email toggle
  if (emailToggle) {
    emailToggle.addEventListener('change', async function() {
      const isEnabled = this.checked;
      const statusElement = emailStatus;
      
      // Set loading state
      setLoadingState(this, true);
      
      // Update status indicator immediately for better UX
      updateStatusIndicator(statusElement, isEnabled);
      
      // Update preferences in Shopify
      const success = await updateCustomerPreferences('Email', isEnabled);
      
      // Remove loading state
      setLoadingState(this, false);
      
      // Revert if update failed
      if (!success) {
        this.checked = !isEnabled;
        updateStatusIndicator(statusElement, !isEnabled);
      }
    });
  }

  // Initialize toggles on page load
  initializeToggles();
}); 